// Stats en direct d'un post publié (POST /insights), mêmes règles de lecture que l'ancien overview (Table.vue)
export const INSIGHTS_NETWORKS = ['facebook', 'instagram', 'linkedin', 'twitter']

const sum = obj => Object.values(obj || {}).reduce((s, v) => s + (Number(v) || 0), 0)
const metric = (key, icon, label, value) => ({ key, icon, label, value: value === undefined || value === null ? 0 : value })

function graphValue(list, names) {
  const found = (list || []).find(i => names.includes(i.name))
  return found && found.values && found.values[0] ? found.values[0].value : undefined
}

// Corps attendu par POST /insights pour un post de last_posts
export function insightsRequest(post) {
  return [{
    _id: post.news_id,
    page: [{
      id: post.bot_uid,
      network: post.network,
      post_number: post.network_post_id,
      post_number_bis: post.post_number_bis,
      video: post.video,
      story: post.story
    }]
  }]
}

/**
 * @returns {Array<{key, icon, label, value}>|null} null si aucune stat exploitable
 */
export function normalizeInsights(network, embed, t) {
  if (!embed || embed.insightsError) return null
  const insights = embed.insights
  if (!insights || (Array.isArray(insights) && !insights.length)) return null

  switch (network) {
    case 'facebook': {
      const reactionsRaw = graphValue(insights, ['post_reactions_like_total', 'total_video_reactions_by_type_total'])
      const videoReactions = graphValue(insights, ['post_video_likes_by_reaction_type'])
      const socialActions = graphValue(insights, ['post_video_social_actions'])
      const reactions = reactionsRaw !== undefined
        ? (typeof reactionsRaw === 'object' ? sum(reactionsRaw) : reactionsRaw)
        : (videoReactions !== undefined ? sum(videoReactions) : 0)
      const list = [
        metric('views', 'visibility', t('dash.reporting.impression'), graphValue(insights, ['post_media_view', 'total_video_impressions', 'fb_reels_total_plays'])),
        metric('reactions', 'favorite_border', t('dash.reporting.reaction'), reactions)
      ]
      if (socialActions) list.push(metric('comments', 'chat_bubble_outline', t('dash.reporting.pdf.comments'), socialActions.COMMENT))
      else list.push(metric('clicks', 'touch_app', t('dash.reporting.clic'), graphValue(insights, ['post_clicks', 'total_video_views_clicked_to_play'])))
      return list
    }
    case 'instagram': {
      const story = insights[0] && insights[0].insights && insights[0].insights.data
      const data = story || insights
      const pairs = story
        ? [['views', 'visibility', 'dash.reporting.impression'], ['replies', 'reply', 'dash.reporting.replies'], ['shares', 'share', 'dash.reporting.pdf.shares']]
        : [['views', 'visibility', 'dash.reporting.impression'], ['likes', 'favorite_border', 'dash.reporting.reaction'], ['comments', 'chat_bubble_outline', 'dash.reporting.pdf.comments'], ['shares', 'share', 'dash.reporting.pdf.shares'], ['saved', 'bookmark_border', 'dash.reporting.pdf.saved']]
      const list = pairs
        .map(([name, icon, label]) => ({ name, icon, label, value: graphValue(data, [name]) }))
        .filter(m => m.value !== undefined)
        .map(m => metric(m.name, m.icon, t(m.label), m.value))
      return list.length ? list : null
    }
    case 'linkedin': {
      const s = insights.totalShareStatistics
      if (!s) return null
      return [
        metric('views', 'visibility', t('dash.reporting.impression'), s.impressionCount),
        metric('reactions', 'favorite_border', t('dash.reporting.reaction'), s.likeCount),
        metric('comments', 'chat_bubble_outline', t('dash.reporting.pdf.comments'), s.commentCount),
        metric('shares', 'share', t('dash.reporting.pdf.shares'), s.shareCount),
        metric('clicks', 'touch_app', t('dash.reporting.clic'), s.clickCount)
      ]
    }
    case 'twitter':
      return [
        metric('views', 'visibility', t('dash.reporting.impression'), insights.impression_count),
        metric('retweets', 'repeat', t('dash.posts.retweet'), insights.retweet_count),
        metric('reactions', 'favorite_border', t('dash.reporting.reaction'), insights.like_count),
        metric('comments', 'chat_bubble_outline', t('dash.reporting.pdf.comments'), insights.reply_count)
      ]
    default:
      return null
  }
}
